"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCircleWrapper = exports.Content = exports.Wrapper = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Wrapper = native_1.default.View `
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.Content = native_1.default.Text `
  color: ${({ theme }) => theme.text.color.tertiary};
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ fontSize }) => Math.floor(1.5 * fontSize)}px;
`;
exports.ProgressCircleWrapper = native_1.default.View `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
